import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '../lib/queryClient'

interface QueryProviderProps {
    children: React.ReactNode
}

/**
 * React Query Provider Component
 * 
 * Wraps the application with React Query context and provides
 * development tools in non-production environments.
 */
export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {/* Only show devtools in development */}
            {import.meta.env.DEV && (
                <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-right"
                    buttonPosition="bottom-right"
                />
            )}
        </QueryClientProvider>
    )
}

export default QueryProvider
